import { render, staticRenderFns } from "./ClientMobileView.vue?vue&type=template&id=697a4ca2&scoped=true&"
import script from "./ClientMobileView.vue?vue&type=script&lang=js&"
export * from "./ClientMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697a4ca2",
  null
  
)

export default component.exports